var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4.56812C19.9949 4.56812 16.0798 5.75576 12.7497 7.98086C9.41962 10.206 6.82412 13.3686 5.29145 17.0688C3.75877 20.769 3.35776 24.8406 4.13911 28.7687C4.92046 32.6968 6.84908 36.305 9.6811 39.137C12.5131 41.969 16.1213 43.8977 20.0494 44.679C23.9775 45.4604 28.0491 45.0593 31.7493 43.5267C35.4496 41.994 38.6122 39.3985 40.8373 36.0684C43.0624 32.7383 44.25 28.8232 44.25 24.8181C44.2441 19.4493 42.1087 14.3021 38.3123 10.5058C34.516 6.70946 29.3688 4.57407 24 4.56812ZM26.25 9.23124C30.2507 9.80969 33.8758 11.9042 36.375 15.0812L26.25 20.9219V9.23124ZM9.37501 30.6625C8.48891 28.4502 8.11675 26.0656 8.28663 23.6886C8.4565 21.3115 9.16396 19.0041 10.3556 16.9403C11.5473 14.8765 13.1921 13.1103 15.1659 11.7749C17.1397 10.4395 19.391 9.56971 21.75 9.23124V23.5187L9.37501 30.6625ZM24 40.5681C21.6181 40.5676 19.2673 40.0262 17.1252 38.9845C14.9831 37.9428 13.1056 36.4282 11.6344 34.555L38.625 18.9737C39.5799 21.3634 39.9347 23.9506 39.6585 26.5091C39.3822 29.0675 38.4832 31.5194 37.0402 33.65C35.5971 35.7807 33.654 37.5254 31.3808 38.7314C29.1075 39.9374 26.5734 40.568 24 40.5681Z",
    fill: "#012448",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPie);
export default __webpack_public_path__ + "static/media/ChartPie.f89fe14b8f6757d1c2ca3b97b1201196.svg";
export { ForwardRef as ReactComponent };